import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { loadMetaPixel } from './utils/metaPixel';
interface AppProps {
  /** Show the rotating "verified purchase" social-proof notifications. */
  showPurchaseNotifications?: boolean;
  /** Show the limited-time countdown / scarcity block. */
  showUrgencySection?: boolean;
}
export function App({
  showPurchaseNotifications = true,
  showUrgencySection = true
}: AppProps) {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <LandingPage showPurchaseNotifications={showPurchaseNotifications} showUrgencySection={showUrgencySection} data-id="element-0" data-mp="2mmlvl877gb6d" />;
}